import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    qRz(method: string, ...args: any[]): void
  }
}

/*

  From docs:

  window.qRz.push(...)

  Usage:

  qRz.push(...)

 */

const windowEntity = 'qRz'

const methods = {
  push: true,
}

type QRZLoggedIn = [
  'QrzTrackLoggedIn',
  {
    name: string
    email: string
    date?: string
  }
]

type QRZSubmit = [
  'QrzTrackSubmit',
  string
]

interface IQRZ {
  push(loggedIn: QRZLoggedIn): void
  push(submit: QRZSubmit): void
}

const qRz = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.qRz),
  eventHandler: (methodName, ...args) => {
    window.qRz[methodName](...args)
  },
}) as unknown as IQRZ


export default qRz

export {
  windowEntity,
  methods,
}
